if (!customElements.get('country-localization')) {
  customElements.define(
    'country-localization',
    class CountryLocalization extends HTMLElement {
      constructor() {
        super();
      }

      async connectedCallback() {
        if (window.Shopify && window.Shopify.designMode) {
          return;
        }

        this.countryCode = await window.getCountryCode();
        this.localizationData = await window.getLocalizationData();
        this.countryData = this.localizationData.countries.find(function(country) {
          return country.code == this.countryCode;
        }.bind(this));
        this.select = this.querySelector('.country-localization__select-input');

        if (this.shouldOpenPopup()) {
          this.initForm();
          this.openPopup();
        }
      }

      shouldOpenPopup() {
        const hasCookie = document.cookie.includes('country_selected=true');

        return !hasCookie && (!this.countryData || this.countryData.isCustom);
      }

      initForm() {
        if (this.select) {
          this.select.innerHTML = this.localizationData.countries.map(function(country) {
            return `<option value="${country.code}">${country.name} (${country.currency} ${country.currencySymbol})</option>`;
          }).join('\n');

          this.select.addEventListener('change', function(event) {
            this.changeCountry(event.target.value);
          }.bind(this));

          // if (this.countryData) {
          //    this.select.value = this.countryData.code;
          //    this.changeCountry(this.countryData.code);
          // }

           const countryCode = this.countryData?.code || window.localizationData.currentCountry;
           this.select.value = countryCode;
           this.changeCountry(countryCode);

          const button = this.querySelector('.country-localization__button');
          
          if (button) {
            button.addEventListener('click', function() {
              window.changeCountry(this.select.value);
              this.closePopup();
            }.bind(this));

          }
        }
      }
      

      changeCountry(countryCode) {
        const label = this.querySelector('.country-localization__select-label');
        const labelValue = this.querySelector('.country-localization__select-label-value');
        const selectedCountry = this.localizationData.countries.find(function(country) {
          return country.code == countryCode;
        });

        if (label && labelValue && selectedCountry) {
          labelValue.textContent = `${selectedCountry.name} (${selectedCountry.currency} ${selectedCountry.currencySymbol})`;

          if (selectedCountry.icon) {
            label.style.setProperty('--icon-url', `url(${selectedCountry.icon})`);
          } else {
            label.style.setProperty('--icon-url', '');
          }
        }
      }

      openPopup() {
        document.body.classList.add('has-country-popup-active');
      }

      closePopup() {
        document.body.classList.remove('has-country-popup-active');
      }
    }
  );
}